<!--勤怠詳細画面-->
<template>
  <div>
    <div class="all_area_w0002 ">
      <!--検索エイア-->
      <div class="search-module_w0002">
        <el-row>
          <el-col :span="4" class="el-col_w0002">
            <div class="grid-content bg-purple readonly_input">
              <span class="span_search_condition_w0002 ">{{$t('MODULE.W0002_LBL_CORPORATION_NAME')}}</span>
              <!--企業-->
              <el-input class=" css-input-width_w0002 " style="margin-top: 8px ;margin-left: 10px" size="small" v-model="companyName" :readonly="true"></el-input>
            </div>
          </el-col>
          <el-col :span="5" class="el-col_w0002">
            <div class="grid-content bg-purple readonly_input">
              <span class="span_search_condition_w0002" size="small">{{$t('MODULE.W0002_LBL_STORE_NAME')}}</span>
              <!--現場名-->
              <el-input class="css-input-width_w0002" style="margin-top: 8px ;margin-left: 10px" size="small" v-model="fieldName" :readonly="true"></el-input>
            </div>
          </el-col>
          <el-col :span="6" class="el-col_w0002">
            <div class="grid-content bg-purple readonly_input">
              <span class="span_search_condition_w0002">{{$t('COMMON.LBL_WORKDAY')}}</span>
              <!--作業日-->
              <el-input class="css-input-width_w0002 " style="margin-top: 8px; margin-left: 10px" size="small" v-model="jobDate" :readonly="true"></el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 作業開始・完了・戻す -->
      <el-row v-show="jobState=='0'" style="text-align:right;">
        <el-button class="css-btn css-button" @click="clickWork" type="primary" style="margin-bottom: 10px;margin-right: 5px;font-size: 10pt;width:34%;" :disabled="NeedReadonly('BTN1')">{{$t('MODULE.W0002_LBL_BTN1_1')}}</el-button>
      </el-row>
      <el-row v-show="jobState=='1'" style="text-align:right;">
        <el-button class="css-btn css-button" @click="clickWork" type="primary" style="margin-bottom: 10px;margin-right: 5px;font-size: 10pt;width:34%;" :disabled="NeedReadonly('BTN1')">{{$t('MODULE.W0002_LBL_BTN1_2')}}</el-button>
      </el-row>
      <el-row v-show="jobState=='2'" style="text-align:right;">
        <el-button class="css-btn css-button" @click="clickWork" type="primary" style="margin-bottom: 10px;margin-right: 5px;font-size: 10pt;width:34%;" :disabled="NeedReadonly('BTN1')">{{$t('MODULE.W0002_LBL_BTN1_3')}}</el-button>
      </el-row>
      <!-- 作業量入力無し -->
      <el-row v-show="jobState=='0'">
        <el-checkbox v-model="w0002btn2CheckBox" class="checkbox_w0002" @change="btn2CheckChange" style="margin-left:10px;" :disabled="NeedReadonly('BTN2')">{{$t('MODULE.W0002_LBL_BTN2')}}</el-checkbox>
      </el-row>
      <el-row v-show="jobState=='1'">
        <el-checkbox v-model="w0002btn2CheckBox" class="checkbox_w0002" @change="btn2CheckChange" style="margin-left:10px;" :disabled="NeedReadonly('BTN2')">{{$t('MODULE.W0002_LBL_BTN2')}}</el-checkbox>
      </el-row>
      <el-row v-show="jobState=='2'">
        <el-checkbox v-model="w0002btn2CheckBox" class="checkbox_w0002" @change="btn2CheckChange" style="margin-left:10px;" :disabled="NeedReadonly('BTN2')">{{$t('MODULE.W0002_LBL_BTN2')}}</el-checkbox>
      </el-row>
      <!--入力エイア-->
      <div class="el-detail_w0002">
        <template v-for="(item,index) in storeWorkCwProductList">
          <el-row v-if="index % 2 === 0 && index < storeWorkCwProductList.length - 1">
            <div class="div_span_w0002 ">
              <span class="input_span_w0002">{{ item.productCd }} <br />{{ item.productName }}</span>
              <span class="input_span_w0002">{{ storeWorkCwProductList[index+1].productCd }} <br />{{ storeWorkCwProductList[index+1].productName }}</span>
            </div>
          </el-row>
          <el-row v-if="index % 2 === 0 &&  index === storeWorkCwProductList.length - 1">
            <div class="div_span_w0002 ">
              <span class="input_span_w0002">{{ item.productCd }} <br />{{ item.productName }}</span>
            </div>
          </el-row>
          <el-row v-if="index % 2 === 0 && index < storeWorkCwProductList.length - 1">
            <div class="div_input_w0002 ">
              <el-input class="input_input1_w0002" v-model="item.productNumbers" :readonly="NeedReadonly('BTN2')" @input="item.productNumbers = numberChk(item.productNumbers)"></el-input>
              <el-input class="input_input1_w0002" v-model="storeWorkCwProductList[index+1].productNumbers" :readonly="NeedReadonly('BTN2')" @input="storeWorkCwProductList[index+1].productNumbers = numberChk(storeWorkCwProductList[index+1].productNumbers)"></el-input>
            </div>
          </el-row>
          <el-row v-if="index % 2 === 0 && index === storeWorkCwProductList.length - 1">
            <div class="div_input_w0002 ">
              <el-input class="input_input1_w0002" v-model="item.productNumbers" :readonly="NeedReadonly('BTN2')" @input="item.productNumbers = numberChk(item.productNumbers)"></el-input>
            </div>
          </el-row>
        </template>
        <!--特記事項-->
        <div class="div_span2_w0002">
          <span class="input_span_w0002">{{$t('MODULE.W0002_LBL_TEXTERA1')}}</span>
        </div>
        </el-row>
        <el-row>
          <el-input v-model="cwNotices" type="textarea" @input="changeFgl = true" maxlength=500 :rows="2" class="input_textarea_w0002" :readonly="NeedReadonly('BTN3')"></el-input>
        </el-row>
        <!-- 受領書無し -->
        <el-row>
        </el-row>
        <el-row>
          <!--受領書写真-->
          <div class="div_span2_w0002">
            <span class="input_span_w0002">{{$t('MODULE.W0002_LBL_PHOTO_INFO')}}</span>
          </div>
        </el-row>
        <!--写真1-->
        <el-row>
          <div style="background-color: #d2eef8;">
            <el-checkbox v-model="w0002btn3CheckBox" @change="fileRemove" class="checkbox_w0002" style="margin-left:10px;" :disabled="NeedReadonly('BTN3')">{{$t('MODULE.W0002_LBL_BTN3')}}</el-checkbox>
          </div>
          <div class="photo_div">
            <div class="image_border" v-if="receiptPhoto1Show"></div>
            <!--图片上传组件-->
            <el-upload ref="upload1" :disabled="NeedReadonly('BTN3')" :show-file-list="true" :file-list="receiptPhoto1ImageList" list-type="picture-card" :limit="5" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="#" :on-change=" (file, fileList)=> {handleChange(file, fileList,'receiptPhoto1','1')}" :auto-upload="false">
              <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
              <div slot="file" slot-scope="{file}">
                <img id="receiptPhoto1" class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'receiptPhoto1')">
                  <span v-if="false" class="el-upload-list__item-delete">
                  </span>
                </span>
              </div>
            </el-upload>
            <!--图片预览用viewer-->
            <el-image-viewer v-if="receiptPhoto1Visible" :class={image_view_red:jobState_working,image_view_hidden:!jobState_working} :on-close="closeViewer1" :url-list="[receiptPhoto1Url]" />
          </div>
        </el-row>
      </div>
      <!--保存-->
      <div>
        <el-row style="text-align:center;">
          <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 10pt;width:20%" @click="save_click" :disabled="NeedReadonly('BTN4')">{{$t('COMMON.BTN_SAVE')}}</el-button>
          <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 10pt;width:20%" @click="back_click">{{$t('COMMON.BTN_BACK')}}</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import * as amsApi from "../api/w_0002"
import css from "@/statics/css"
import utilsApi from '../../common/utils'
let url = require('@/../config/sysConfig')
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  mixins: [css],
  components: {
    ElImageViewer
  },
  data() {
    return {
      companyName: '',
      fieldName: '',
      jobDate: '',//作業日
      userInfo: '',
      crewCd: '',// クルーコード
      jobState: '',//  作業状態
      cwNotices: '',// 特記事項
      cwStoreSign: '',//店舗責任者サイン
      week: '',// 曜日
      fieldCd: '',// 現場CD
      salesOfficeCd: '',
      receiptPhoto: '',// 受領書写真(pathです)
      obj: [],
      photoUid: '',//fileUid
      receiptPhoto1Url: '',//图片1预览用的单张图片
      storeWorkCwProductList: [],// 商品情報リスト
      receiptPhoto1ImageList: [],//图片1初始化时的list
      updateReceiptPhotoList: [],//update用PhotoList
      receiptPhoto1LongClick: false,//是否为图片1长按模式（true=长按模式）。
      has_UpdateLoadedDel: false,//是否上传成功过
      w0002btn2CheckBox: false,// 作業量入力無しnoAmountInput
      w0002btn3CheckBox: false,// 受領書無しnoReceipt
      receiptPhoto1Visible: false,//图片1dialog是否显示flag
      receiptPhoto1Show: true,//是否显示假图片框1
      changeFgl: false,
      transmitFlag: '',
      updateParams: {},
      photoFormData: {}
    }
  },
  methods: {
    // 検索
    query() {
      var Params = {
        'crewCd': this.crewCd,
        'week': this.week
      }
      // 検索処理
      this.set_loading()
      amsApi.w_0002_search(Params).then(async res => {
        this.storeWorkCwProductList = res.items.storeWorkCwProductList
        this.transmitFlag = res.items.transmitFlag
        this.salesOfficeCd = res.items.salesOfficeCd
        this.jobState = res.items.jobState
        if (this.jobState == '1') {
          this.jobState_working = true
        } else {
          this.jobState_working = false
        }
        this.cwNotices = res.items.cwNotices
        this.w0002btn2CheckBox = res.items.noAmountInput == '0' ? false : true
        this.w0002btn3CheckBox = res.items.noReceipt == '0' ? false : true
        // 写真检索
        if (res.items.receiptPhoto) {
          for (const item of res.items.receiptPhoto.split(',')) {
            await this.download_Get(item, '1')
          }
        }
      })
      this.close_loading()
    },
    btn2CheckChange() {
      for (const item of this.storeWorkCwProductList) {
        if (item.productNumbers !== null && item.productNumbers !== '') {
          this.$confirm(this.$t('COMMON.MSG_WORK_AMOUNT_CLR'), { // 作業数量をリセットします、よろしいですか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true
          }).then(() => {
            for (const item of this.storeWorkCwProductList) {
              item.productNumbers = null
            }
            this.w0002btn2CheckBox = true
          }).catch(() => {
            this.w0002btn2CheckBox = false
          })
          break;
        }
      }
      this.changeFgl = true
    },
    // 保存按钮事件
    save_click() {
      this.$confirm(this.$t('COMMON.MSG_SAVE'), { // 保存します。よろしいでしょうか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(() => {
        this.set_loading()
        this.updateParams.div = '0'
        this.updateParams.crewCd = this.crewCd
        this.updateParams.jobState = '1'
        this.updateParams.cwNotices = this.cwNotices
        this.updateParams.cwStoreSign = ''
        for (const item of this.storeWorkCwProductList) {
          item.productNumbers = item.productNumbers == '' ? null : item.productNumbers
        }
        this.updateParams.productList = this.storeWorkCwProductList
        this.updateParams.week = this.week
        this.updateParams.salesOfficeCd = this.salesOfficeCd
        this.updateParams.fieldCd = this.fieldCd
        this.updateParams.jobDate = this.jobDate
        this.updateParams.noAmountInput = this.w0002btn2CheckBox == false ? '0' : '1';
        this.updateParams.noReceipt = this.w0002btn3CheckBox == false ? '0' : '1';
        // Image更新
        this.receiptPhoto = ''
        // 初始receiptPhoto変化判断
        for (const item of this.$refs.upload1.uploadFiles) {
          if (item.filePath) {
            if (this.receiptPhoto !== '') {
              this.receiptPhoto = this.receiptPhoto + item.filePath + ','
            } else {
              this.receiptPhoto = item.filePath + ','
            }
          }
        }
        console.log(this.receiptPhoto)
        this.photoFormData = new FormData()
        // 新receiptPhoto保存
        for (const item of this.updateReceiptPhotoList) {
          this.photoFormData.append('files', item.files, item.photoPath)
          this.receiptPhoto = this.receiptPhoto + item.photoPath + ','
        }
        this.receiptPhoto = this.receiptPhoto.slice(0, -1);
        if (this.updateReceiptPhotoList.length > 0) {
          this.updateParams.receiptPhoto = this.receiptPhoto
          var that = this
          amsApi.w_0002_saveImage(this.photoFormData).then(res => {
            if (res.code == 205) {
              amsApi.w_0002_update(this.updateParams).then(res => {
                this.res_code_back(res)
              })
            } else if (res.code == 311) {
              that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
            }
          })
        } else {
          this.updateParams.receiptPhoto = this.receiptPhoto
          amsApi.w_0002_update(this.updateParams).then(res => {
            this.res_code_back(res)
          })
        }
        this.close_loading()
      }).catch(() => {
      })
    },
    //「作業開始／作業完了／戻す」ボタン処理
    clickWork() {
      let param = {}
      param.jobDate = this.jobDate
      param.crewCd = this.crewCd
      param.gamenId = 'W_0002'
      if (this.jobState == '0') {
        param.checkFlg = '1'
        param.btnType = '1'
        this.$confirm(this.$t('COMMON.MSG_STOREIN_COMFIRM'), this.$t('COMMON.CONFIRM'), { // 作業開始します。よろしいでしょうか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true,
          customClass: 'w0002_confirmStyle',
          type: 'warning'
        }).then(() => {
          utilsApi.jobStateEdit(param).then(res => {
            if (res.code == 406) {//システム時刻がパラメータ.最小の入店より1時間以上早い場合
              this.$confirm(this.$t('COMMON.MINSTOREIN_CHECK'), this.$t('COMMON.CONFIRM'), { // クルーイングより1時間以上早いです。開始してよろしいでしょうか。"
                confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
                center: true,
                customClass: 'w0002_confirmStyle',
                type: 'warning'
              }).then(() => {
                param.checkFlg = '0'
                utilsApi.jobStateEdit(param).then(res2 => {
                  this.res_code_back(res2)
                })
              }).catch(() => {
                // いいえ
              })
            } else {//その他
              this.res_code_back(res)
            }
          })
        }).catch(() => {
          // いいえ
        })
      } else if (this.jobState == '1') {
        param.checkFlg = '1'
        param.btnType = '2'
        utilsApi.jobStateEdit(param).then(res => {
          if (res.code == 405) {
            // 店舗サインがありません。作業完了してもよろしいですか？
            setTimeout(() => {
              this.$confirm(this.$t('COMMON.SOTRESIGN_NOT_INPUT'), this.$t('COMMON.CONFIRM'), {
                confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
                center: true,
                customClass: 'w0002_confirmStyle',
                type: 'warning'
              }).then(() => {
                param.checkFlg = '0'
                utilsApi.jobStateEdit(param).then(res => {
                  this.res_code_back(res)
                })
                // this.changeFgl = false
                // var vm = this
                // vm.$router.push({ path: url.routerUrl_W0001 })
              }).catch(() => { })
            }, 500)
          } else {
            setTimeout(() => {
              this.$confirm(this.$t('COMMON.MSG_STOREOUT_COMFIRM_MSG'), this.$t('COMMON.CONFIRM'), { // 作業完了します。よろしいですか？
                confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
                center: true,
                customClass: 'w0002_confirmStyle',
                type: 'warning'
              }).then(() => {
                param.checkFlg = '0'
                utilsApi.jobStateEdit(param).then(res => {
                  this.res_code_back(res)
                })
              }).catch(() => {
                // いいえ
              })
            }, 500)
          }
        })
      } else if (this.jobState == '2') {
        param.checkFlg = '0'
        param.btnType = '3'
        this.$confirm(this.$t('COMMON.MSG_STOREOUT_BACK_MSG'), this.$t('COMMON.CONFIRM'), { // 作業中に戻ります。よろしいですか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true,
          customClass: 'w0002_confirmStyle',
          type: 'warning'
        }).then(() => {
          utilsApi.jobStateEdit(param).then(res => {
            this.res_code_back(res)
          })
        }).catch(() => {
          // いいえ
        })
      }
    },
    //readonly判定
    NeedReadonly(flag) {
      var readonlyReturn = true
      switch (flag) {
        //作業開始・完了・戻すReadonly
        case "BTN1":
          if (this.transmitFlag !== '1') {
            readonlyReturn = false
          }
          break
        //作業量入力無しReadonly/productNumbersReadonly
        case "BTN2":
          if (this.jobState === '1' && this.jobDate === utilsApi.timeDefault()) {
            readonlyReturn = false
          }
          break
        // 受領書無しReadonly/受領書写真Readonly/特記事項Readonly
        case "BTN3":
          if (this.jobState === '1') {
            readonlyReturn = false
          }
          break
        // 保存Readonly
        case "BTN4":
          if (this.jobState === '1') {
            readonlyReturn = false
          }
          break
      }
      return readonlyReturn
    },
    numberChk(val) {
      this.changeFgl = true
      for (const item of this.storeWorkCwProductList) {
        let tempVal = utilsApi.validitMoney(val, 9, 2);
        if (tempVal !== null && tempVal !== '') {
          this.w0002btn2CheckBox = false
          break
        }
      }
      val = utilsApi.validitMoney(val, 9, 2)
      return val
    },
    //图片删除
    fileRemove() {
      this.changeFgl = true
      if (this.$refs.upload1.uploadFiles.length !== 0) {
        this.$confirm(this.$t('COMMON.MSG_WORK_PIC_DEL'), { // 作業数量をリセットします、よろしいですか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: true
        }).then(() => {
          //组件表示图片清空
          this.$refs.upload1.clearFiles()
          //上传用list清空
          this.updateReceiptPhotoList = []
          this.receiptPhoto1Show = true
          this.has_UpdateLoadedDel = true
          this.changeFgl = true
          this.w0002btn3CheckBox = true
        }).catch(() => {
          this.w0002btn3CheckBox = false
        })
      }
    },
    //单张图片点击
    handlePictureCardPreview(file, itemName) {
      this[itemName + 'Url'] = file.url;
      this[itemName + 'Visible'] = true;
      this.photoUid = file.uid
    },
    // 画像上传成功后处理
    handleChange(file, fileList, itemName, type) {
      var file_type = file.raw.type
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpeg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(fileList.length - 1, 1);
        }
      } else {
        //变更flg设定
        this.changeFgl = true
        //假图片框若有的话，隐藏
        if (this[itemName + 'Show'] == true) {
          this[itemName + 'Show'] = false
        }
        //执行过图片操作处理
        this.has_UpdateLoadedDel = true
        this.w0002btn3CheckBox = false
        var that = this
        this.getBase64(file.raw).then(async res => {
          // 进行图片压缩获取压缩后的blob文件
          var photo = await that.compressImg(that.base64ToBlob(res))
          let files = new window.File([photo], file.name, { type: file.type })
          let timenumber = utilsApi.timeNumberGet()
          //拡張子
          let exhibitionName = file.name.split('.')[1];
          let photoPath = 'image/workreceipt/' + that.crewCd + '/workreceipt' + '_' + timenumber + '.' + exhibitionName
          this.updateReceiptPhotoList.push({
            'uid': file.uid,
            'files': files,
            'photoPath': photoPath
          })
        })
      }
    },

    // 图片转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },

    // base转blob
    base64ToBlob(file) {
      let byteString;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1])
      } else {
        byteString = unescape(file.split(',')[1])
      }
      let mimeString = file
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      let ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    },

    // 压缩图片
    compressImg(file) {
      var that = this
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new Promise(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
              h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);

            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToBlob(base64); //如果后台接收类型为base64的话这一步可以省略
            resolve(files)
          };
        };
      })
    },
    // 关闭查看器
    closeViewer1() {
      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), { // 写真を削除します。よろしいですか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(() => {
        //this.$refs.upload1.clearFiles()
        this.$refs.upload1.uploadFiles = this.$refs.upload1.uploadFiles.filter(item => item.uid !== this.photoUid);
        this.updateReceiptPhotoList = this.updateReceiptPhotoList.filter(item => item.uid !== this.photoUid);
        this.receiptPhoto1Show = this.$refs.upload1.uploadFiles.length == 0 ? true : false
        this.receiptPhoto1Visible = false
        this.has_UpdateLoadedDel = true
        this.changeFgl = true

      }).catch(() => {

      })
    },
    /* 图片压缩方法-canvas压缩 */
    compressUpload(image, file) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let initSize = image.src.length
      let { width } = image, { height } = image
      canvas.width = width
      canvas.height = height
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(image, 0, 0, width, height)
      // 进行最小压缩0.5
      let isLt2M = file.size / 1024 / 1024
      let compressData;
      if (5 < isLt2M < 10) {
        compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.1)
      } else {
        compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.5)
      }
      //压缩后调用方法进行base64转Blob，方法写在下边
      let blobImg = this.dataURItoBlob(compressData)
      return blobImg
    },
    // 写真检索
    async download_Get(filePath, type) {
      this['receiptPhoto' + type + 'ImageList'] = []
      amsApi.w_0002_getImage(filePath).then(res_photo => {
        let blob = new Blob([res_photo], { type: 'image/jpeg' })
        var url = window.URL.createObjectURL(blob)

        this['receiptPhoto' + type + 'ImageList'].push({ url: url, filePath: filePath })
        this['receiptPhoto' + type + 'Show'] = false


      }).catch((err) => {

      })
    },
    // 退出登录处理
    log_out() {
      this.$message.closeAll()
      var vm = this
      vm.$router.push({ path: "/login" })
    },
    // 戻る処理
    back_click() {
      // this.$alert(this.$t('COMMON.UPDATED'), this.$t('COMMON.CONFIRM'), {//更新しました。
      //   confirmButtonText: this.$t('COMMON.CONFIRM'), // 確認
      //   center: true,
      //   customClass: 'w0002_confirmStyle',
      //   type: 'success'
      // }).then(() => {
      //   var vm = this
      //   vm.$router.push({ path: url.routerUrl_W0001 })
      // })
      if (this.changeFgl === true) {
        this.$confirm(this.$t('COMMON.MSG_RETRUN'), { // 変更がありました。一覧に戻りますか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: true
        }).then(() => {
          var vm = this
          vm.$router.push({ path: url.routerUrl_W0001 })
        }).catch(() => {
        })
      } else {
        var vm = this
        vm.$router.push({ path: url.routerUrl_W0001 })
      }
    },
    // 数据保存的返回值（res_code）処理
    res_code_back(res) {
      if (res.code == 201 || res.code === 202) {
        this.changeFgl = false
        this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
        //更新成功的场合，图片操作初始化false
        this.has_UpdateLoadedDel = false
        this.updateReceiptPhotoList = []
        this.query()
      } else if (res.code === 308) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.EXCLUSIVE'), this.$t('COMMON.CONFIRM'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true,
            customClass: 'w0002_confirmStyle',
            type: 'warning'
          }).then(() => {
            this.changeFgl = false
            var vm = this
            vm.$router.push({ path: url.routerUrl_W0001 })
          }).catch(() => {
          })
        }, 500)
      } else if (res.code == 310) {
        //システム日（yyyy/MM/dd）がパラメータ.作業日と異なる場合
        this.$message.error({ message: this.$t('COMMON.MSG_STOREIN_CHECK'), showClose: true });
      } else if (res.code == 311) {
        // 戻り値コードが「311」の場合、戻り値メッセージを表示し、処理失敗。
        //保存失敗
        this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });
        this.close_loading()
      } else if (res.code === 408) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.MSG_ERROR_STATE_OVER'), this.$t('COMMON.CONFIRM'), { // 作業状態はもう作業完了でした。他の人が先に更新した可能性があります。最新情報を取得しますか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true,
            customClass: 'w0002_confirmStyle',
            type: 'warning'
          }).then(() => {
            this.changeFgl = false
            var vm = this
            vm.$router.push({ path: url.routerUrl_W0001 })
          }).catch(() => {
          })
        }, 500)
      } else if (res.code == 417) {
        setTimeout(() => {
          // 戻り値コードが「417」（店舗サイン済確認）の場合、戻り値メッセージを表示する。メッセージ種類：確認メッセージ
          this.$confirm(this.$t('COMMON.STORE_SIGN_CHECK'), this.$t('COMMON.CONFIRM'), {
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),
            center: true,
            customClass: 'w0002_confirmStyle',
            type: 'warning'
          }).then(() => {
            //はい
            this.updateFunction_b();
          }).catch(() => {
            //いいえ
          });
        }, 500)
      } else if (res.code == 426) {
        // 戻り値コードが「426」の場合、MH予測(カゴ車)更新失敗、戻り値メッセージを表示する。
        //商品数量が大きいすぎます。ご確認ください。
        this.$message.error({ message: this.$t('MODULE.W0002_NO_MHCHECK'), showClose: true });
      } else if (res.code == 618) {
        //処理コードが「618」の場合、入力必須の商品数量は入力していない、エラーメッセージを表示する。
        //商品CD({0})の数量は入力必須です。
        this.$message.error({ message: (this.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK3')).replace('{0}', res.items.errorData.description[0].itemName), showClose: true });
      } else if (res.code == 449) {
        //処理コードが「449」の場合、商品数量＞最大値、エラーメッセージを表示する。
        //商品CD({0})は数量＜＝{1}で入力してください。
        this.$message.error({ message: (this.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK1').replace('{0}', res.items.errorData.description[0].itemName)).replace('{1}', res.items.errorData.description[0].itemValue), showClose: true });
      } else if (res.code == 450) {
        //処理コードが「450」の場合、商品数量は最小単位の整数倍ではない、エラーメッセージを表示する。
        //商品CD({0})は数量が{1}の整数倍で入力してください。
        this.$message.error({ message: (this.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK2').replace('{0}', res.items.errorData.description[0].itemName)).replace('{1}', res.items.errorData.description[0].itemValue), showClose: true });
      } else if (res.code == 412) {
        // 既に「作業中」です。他の人が先に更新した可能性があります。最新情報を取得しますか？
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.STATE_ING'), this.$t('COMMON.CONFIRM'), {
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true,
            customClass: 'w0002_confirmStyle',
            type: 'warning'
          }).then(() => {
            this.changeFgl = false
            var vm = this
            vm.$router.push({ path: url.routerUrl_W0001 })
          }).catch(() => { })
        }, 500)
      } else if (res.code == 614) {
        //ステータスが「クルー確定」以外のスケジュールは開始できません。
        this.$message.error({ message: this.$t('COMMON.MSG_STATUS_ERROR'), showClose: true });
      } else if (res.code == 428) {
        // 店舗サインがありません。作業完了してもよろしいですか？
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.MSG_TRANSMIT'), this.$t('COMMON.CONFIRM'), {
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true,
            customClass: 'w0002_confirmStyle',
            type: 'warning'
          }).then(() => {
            this.changeFgl = false
            var vm = this
            vm.$router.push({ path: url.routerUrl_W0001 })
          }).catch(() => { })
        }, 500)
      } else if (res.code == 402) {//入店・退店時刻は未入力の勤怠があるため
        this.$message.error({ message: this.$t('COMMON.STORETIME_NOT_INPUT'), showClose: true });
      } else if (res.code == 424) {//作業実績がないため
        this.$message.error({ message: this.$t('COMMON.WORK_NOT_INPUT'), showClose: true });
      } else if (res.code == 632) {//現場曜日別商品が変更されました。作業実績を再保存してください。
        this.$message.error({ message: this.$t('COMMON.MSG_PRODUCT_UNMATCH'), showClose: true });
      }
    },
    updateFunction_b() {
      this.updateParams.div = '2'
      //调用服务端接口
      amsApi.w_0002_update(this.updateParams).then((res) => {
        var code = res.code;
        switch (code) {
          case 202:
            //戻り値コードが「202」の場合、戻り値メッセージを表示し、画面をリフレッシュし、処理完了。
            this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true });//保存成功
            this.changeFgl = false
            this.has_UpdateLoadedDel = false
            this.updateReceiptPhotoList = []
            this.query();
            break;
          case 308:
            // 戻り値コードが「308」の場合、排他エラーになり、戻り値メッセージを表示する
            //処理が失敗しました。他の人が先に更新した可能性があります。最新情報を取得しますか。
            setTimeout(() => {
              this.$confirm(this.$t('COMMON.EXCLUSIVE'), this.$t('COMMON.CONFIRM'), {//排他発生になる
                confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//を選択します
                cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//キャンセル
                center: true,
                customClass: 'w0002_confirmStyle',
                type: 'warning',
              }).then(() => {
                //はい
                this.changeFgl = false
                this.query();
              }).catch(() => {
                //いいえ
              });
            }, 500)
            break;
          case 311:
            // 戻り値コードが「311」の場合、戻り値メッセージを表示し、処理失敗。
            this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
            break;
          case 426:
            // 戻り値コードが「426」の場合、MH予測(カゴ車)更新失敗、戻り値メッセージを表示する。
            this.$message.error({ message: this.$t('MODULE.W0002_NO_MHCHECK'), showClose: true });//商品数量が大きいすぎます。ご確認ください。
            break;
          case 618:
            //処理コードが「618」の場合、入力必須の商品数量は入力していない、エラーメッセージを表示する。
            //商品CD({0})の数量は入力必須です。
            this.$message.error({ message: (this.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK3')).replace('{0}', res.items.errorData.description[0].itemName), showClose: true });
            break;
          case 449:
            //処理コードが「449」の場合、商品数量＞最大値、エラーメッセージを表示する。
            //商品CD({0})は数量＜＝{1}で入力してください。
            this.$message.error({ message: (this.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK1').replace('{0}', res.items.errorData.description[0].itemName)).replace('{1}', res.items.errorData.description[0].itemValue), showClose: true });
            break;
          case 450:
            //処理コードが「450」の場合、商品数量は最小単位の整数倍ではない、エラーメッセージを表示する。
            //商品CD({0})は数量が{1}の整数倍で入力してください。
            this.$message.error({ message: (this.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK2').replace('{0}', res.items.errorData.description[0].itemName)).replace('{1}', res.items.errorData.description[0].itemValue), showClose: true });
            break;
        }
      });
    },
  },
  // 初期化自动调用
  created() {
    this.obj = JSON.parse(localStorage.getItem('obj'))
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.crewCd = this.obj.crewCd
    this.jobDate = this.obj.jobDate
    this.fieldCd = this.obj.fieldCd
    this.fieldName = this.obj.fieldName
    this.companyName = this.obj.companyName
    this.jobState = this.obj.jobState
    this.week = utilsApi.getWeek(this.jobDate)
    this.query()
    if (this.jobState == '1') {
      this.jobState_working = true
    } else {
      this.jobState_working = false
    }
  },
  mounted() {
    //点击删除按钮之外的地方退出长按模式
    let that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-icon-delete') {
        that.receiptPhoto1LongClick = false//是否为图片长按模式（true=长按模式）。
      }
      if (e.target.className != 'el-upload-list__item-actions'
        && e.target.className != 'el-icon-refresh-left'
        && e.target.className != 'el-icon-refresh-right'
        && e.target.className != 'el-icon-c-scale-to-original'
        && e.target.className != 'el-icon-zoom-in'
        && e.target.className != 'el-icon-zoom-out'
        && e.target.className != 'el-image-viewer__actions__inner'
        && e.target.className != 'el-icon-full-screen'
        && e.target.className != 'el-icon-circle-close'
        && e.target.className != 'el-button el-button--default el-button--small'
      ) {
        that.receiptPhoto1Visible = false
      }
    })

  }
}
</script>
<style scope>
.btn-custom-cancel_w0002 {
  background-color: #409eff !important;
  color: #ffffff !important;
}
.btn-custom-confirm_w0002 {
  border: 1px solid #dcdfe6 !important;
  background-color: #ffffff !important;
  color: #000000 !important;
}
/*panel下全部区域*/
.all_area_w0002 {
  margin-left: 0px;
}
/*检索条件整体样式*/
.span_search_condition_w0002 {
  padding-left: 20px;
  font-size: 10pt;
}
/*下半部入力框内部长度 第一行*/
.textRight .el-input__inner {
  text-align: right;
}
.textLeft .el-input__inner {
  text-align: left;
}
/*按钮样式*/
.Location_w0002 {
  position: relative;
  top: 50%;
  left: 50%;
  height: 30%;
  text-align: center;
  padding: 20px;
}
/*上半部行样式*/
.el-row_w0002 {
  margin-bottom: 10px;
}
/*上半部列样式*/
.el-col_w0002 {
  border-radius: 4px;
  width: 100%;
}

/*下半部span样式*/
.input_span_w0002 {
  padding: 0px 0px 0px 21px;
  float: left;
  height: 30px;
  min-height: 30px;
  color: #ffffff;
  width: 40%;
}
.input_span2_w0002 {
  float: left;
  height: 30px;
  min-height: 30px;
  color: #ffffff;
  width: 20%;
}
/*下半部span用div样式*/
.div_span_w0002 {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  width: 100%;
  height: 60px;
  line-height: 30px;
  overflow: hidden;
  margin: 0px;
  border: 0;
  padding: 0;
  font-size: 10pt;
}
/*下半部span用div样式*/
.div_span2_w0002 {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  width: 100%;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  margin: 0px;
  border: 0;
  padding: 0;
  font-size: 10pt;
}
/*下半部input用div样式*/
.div_input_w0002 {
  width: 100%;
  height: 55px;
  line-height: 50px;
  background: #d2eef8;
  float: left;
  margin: 0px;
  border: 0;
  padding: 0;
}
/*textarea用div框样式*/
.div_textarea_w0002 {
  width: 100%;
  height: 70px;
  line-height: 50px;
  background: #d2eef8;
  float: left;
  margin: 0px;
  border: 0;
  padding: 0;
}
.input_textarea_w0002 {
  width: 85%;
  min-width: 40%;
  padding: 8px 0px 6px 20px;
  float: left;
  min-height: 30px;
  color: #000000;
  vertical-align: top;
}

.all_area_w0002 .el-textarea__inner {
  resize: none;
}
/*image用div样式*/
.div_image {
  background: #d2eef8;
}
/*下半部input样式 第一行*/
.input_input1_w0002 {
  width: 40%;
  min-width: 40%;
  padding: 3px 0px 0px 20px;
  float: left;
  min-height: 30px;
  color: #000000;
  vertical-align: top;
}
.input_input2_w0002 {
  width: 20%;
  min-width: 20%;
  float: left;
  min-height: 30px;
  color: #000000;
  vertical-align: top;
}
.input_input3_w0002 {
  width: 20%;
  min-width: 20%;
  float: left;
  min-height: 30px;
  color: #918d8d;
  vertical-align: top;
}
/*下半部整体div样式*/
.el-detail_w0002 {
  margin-top: 5px;
  width: 100%;
  height: 100%;
}
.el-input__inner {
  line-height: 20px;
}
/* 分割线上下外边距 */
.c0004-divider .el-divider--horizontal {
  margin-top: 8px;
  margin-bottom: 8px;
}
/*只读框字体颜色*/
.readonly_input .el-input .el-input__inner {
  border-color: rgb(228, 231, 237);
  color: #818181;
}
/*只读框字体颜色1*/
.readonly_input1 .el-input .el-input__inner {
  border-color: rgb(228, 231, 237);
  background-color: rgb(239, 240, 243);
  color: #acacaa;
}
.readonly_textarea .el-textarea .el-textarea__inner {
  border-color: rgb(228, 231, 237);
  background-color: rgb(239, 240, 243);
  color: #acacaa;
}
.readonly_input1.el-input.is-disabled .el-input__inner {
  border-color: rgb(228, 231, 237);
  background-color: rgb(239, 240, 243);
  -webkit-text-fill-color: #acacaa;
  opacity: 1;
}
.readonly_input1 input:disabled {
  -webkit-text-fill-color: #acacaa;
}
/*safari用 去掉入力框阴影*/
.all_area_w0002 textarea {
  -webkit-appearance: none;
}
/*input输入框*/
.css-input-width_w0002 {
  width: 72%;
}
.search-module_w0002 {
  padding-bottom: 10px;
  margin-bottom: 10px; /*检索模块与表格间距*/
  width: 100%;
  background-image: linear-gradient(#f8f6f6, #dfdfdf);
}
/*面包屑*/
.el-crumb_w0002 {
  background-image: linear-gradient(#5c5d5d, #717171);
  padding-left: 5px;
  padding-top: 4px;
  height: 20px;
}
/*导航*/
.home-content-menu_w0002 {
  padding-left: 0;
  height: 40px;
  background-color: #23b2e8;
}

.all_area_w0002 .avatar-uploader .el-upload {
  margin-top: 8px;
  height: 38px;
  width: 100%;
  border: 1px solid #8a8989;
  border-radius: 6px;
}
.all_area_w0002 .avatar-uploader .el-upload:hover {
  border-color: #409eff;
  width: 100%;
  height: 38px;
}
.all_area_w0002 .photo {
  float: left;
  width: 20%;
  height: 40px;
  margin-left: 20px;
}

.all_area_w0002 .photo_button {
  float: left;
  width: 20%;
  margin-left: 5px;
}
/* 去除上传图片动画 */
.all_area_w0002 .el-upload-list__item {
  transition: none !important;
}
.all_area_w0002 .el-upload-list__item-actions {
  padding-left: 15px;
  padding-top: 14px;
  height: 60px;
}
/* 假图片边框 */
.all_area_w0002 .image_border {
  float: left;
  width: 46px;
  height: 46px;
  margin-left: 13px;
  margin-top: 7px;
  position: relative;
  border: 1px solid #409eff;
  border-radius: 5px;
}
/* timesheet整体样式 */
.all_area_w0002 .photo_div {
  height: 70px;
  background-color: #d2eef8;
}
/* timesheet右半部分 */
.all_area_w0002 .photo_div .el-upload--picture-card {
  width: 60px;
  height: 50px;
  margin-top: 7px;
  margin-left: 10px;
  background-color: #d2eef8;
  border: 1px solid #409eff;
  line-height: 0;
}
/* timesheet左半部分 */
.all_area_w0002 .photo_div .el-upload-list--picture-card .el-upload-list__item {
  width: 48px;
  height: 48px;
  margin-top: 7px;
  margin-left: 9px;
  margin-right: 0px;
}
/* timesheet中间照相机ICON式样 */
.all_area_w0002 .photo_div .el-upload--picture-card i {
  margin-top: 12px;
  color: #409eff;
}
/*预览图右上角叉*/
/* .all_area_w0002 .el-icon-circle-close:before {
  color: #fd270a;
} */
.image_view_red .el-icon-circle-close:before {
  color: #fd270a;
}
.image_view_hidden .el-icon-circle-close:before {
  display: none;
}
.checkbox_w0002 .el-checkbox__label {
  font-size: 13px;
  margin-bottom: 0px;
}
.w0002-confirmbtn-css {
  margin-left: 300px;
}

.w0002_confirmStyle .el-message-box__title {
  justify-content: left;
}
</style>





// WEBPACK FOOTER //
// src/module/page/w_0002.vue